/**
 * Left and Right Text Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initLeftAndRightText() {
        const blocks = document.querySelectorAll('.left-and-right-text');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] left-and-right-text block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLeftAndRightText);
    } else {
        initLeftAndRightText();
    }
})();